// src/App.js
import React, { useState, useEffect } from 'react';
import { useAuth } from './contexts/AuthContext';
import AdminPanel from './components/AdminPanel';
import SignatureView from './components/SignatureView';
import VerificationView from './components/VerificationView';
import Login from './components/Login';
import LoadingSpinner from './components/LoadingSpinner';

function App() {
  const [viewType, setViewType] = useState('login');
  const [documentToken, setDocumentToken] = useState(null);
  const { isAuthenticated, loading } = useAuth();

  // Detectar tipo de vista basado en la URL
  useEffect(() => {
    detectViewType();
  }, []);

  // Cambiar vista cuando cambia la autenticación
  useEffect(() => {
    if (!loading) {
      if (isAuthenticated && viewType === 'login') {
        setViewType('admin');
      } else if (!isAuthenticated && viewType !== 'signature' && viewType !== 'verification') {
        setViewType('login');
      }
    }
  }, [isAuthenticated, loading, viewType]);

  const detectViewType = () => {
    const path = window.location.pathname;
    
    const signMatch = path.match(/\/firmar\/([a-f0-9-]+)/);
    if (signMatch && signMatch[1]) {
      setDocumentToken(signMatch[1]);
      setViewType('signature');
      return;
    }
    
    const verifyMatch = path.match(/\/verificar\/([a-f0-9-]+)/);
    if (verifyMatch && verifyMatch[1]) {
      setDocumentToken(verifyMatch[1]);
      setViewType('verification');
      return;
    }
  };

  // Mostrar loading mientras verifica autenticación
  if (loading) {
    return <LoadingSpinner />;
  }

  // Renderizar vista según el tipo
  if (viewType === 'signature' && documentToken) {
    return <SignatureView token={documentToken} />;
  }
  
  if (viewType === 'verification' && documentToken) {
    return <VerificationView token={documentToken} />;
  }

  if (viewType === 'login') {
    return <Login />;
  }

  return <AdminPanel />;
}

export default App;